const Consultation = () => {
  return (
    <div className="contact-consultation">
      <div className="contact-consultation-content">
        <h2>At AAYOJAN, We Bring Your Vision To Life</h2>
        <p>
          Take the first step toward creating unforgettable experiences by
          contacting us today. Schedule a consultation with one of our event
          specialists to discuss your vision, and let us show you how our
          creativity and expertise can turn your ideas into reality.
        </p>
      </div>
      <div className="contact-consultation-button">
        <button className="consultation-button">Request Consultation</button>
        <button className="explore-button">Explore Solution</button>
      </div>
    </div>
  );
};

export default Consultation;
